// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__c81-L","modal":"modal_modal__LmSD9","content":"modal_content__CyN8R","close":"modal_close__DTBme","container-btn":"modal_container-btn__dDERh"};